import React from 'react';
import { CircularProgress } from '@material-ui/core';
// import { ReactComponent as Logo } from '../../assets/logo_loader.svg';
// import Logo from '../../assets/logo_sgsante.svg';

import './Loader.scss';

type Props = {
    loading: boolean;
    children?: React.ReactNode;
    small?: boolean;
    transparent?: boolean;
    opacity?: number;
    containerName?: string;
};

const Loader: React.FC<Props> = ({
    transparent = false,
    opacity,
    loading,
    children,
    small = false,
    containerName = '',
}) => {
    return (
        <div className={containerName}>
            {small && <></>}
            {loading ? (
                <div className={'loader-container'}>
                    <div className="loader-overlay" style={{ opacity: opacity ?? (transparent ? 0.8 : 1) }}></div>
                    <div className="loader">
                        <CircularProgress size={small ? 50 : 100} thickness={1} disableShrink />
                        {/* <Logo className="test-loader" /> */}
                        {/* <img src={Logo} /> */}
                    </div>
                    {children}
                </div>
            ) : (
                children
            )}
        </div>
    );
};

export const PageLoader = (props: Props) => <Loader small opacity={0.2} {...props} />;

export default Loader;
